import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

/** Elevated content surface used below page heroes. */
export default function PatientPortalCard({ children, className = '' }: Props) {
  return (
    <div
      className={`rounded-2xl bg-white/95 backdrop-blur-sm shadow-lg shadow-slate-200/60 ring-1 ring-slate-200/80 p-5 sm:p-6 ${className}`}
    >
      {children}
    </div>
  );
}
